<template>
<section>
    <v-container>
        <v-row justify="start">
          <v-toolbar-title
            class="grey--text text--darken-4 font-weight-black my-5 ml-12"
            >
            Stock Balance
          </v-toolbar-title>
           <v-spacer />
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
          >
          </v-text-field>
          <v-spacer />

          <div class="text-center">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  append-icon="filter_alt"
                  v-model="searchResident"
                  label="Filter By Resident"
                  single-line
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  />
              </template>
              <v-list style="max-height: 100px" v-model="searchResident">
                <v-list-item
                  v-for="(item, index) in residents"
                  :key="index"
                  v-bind="item"
                >
                  <v-list-item-title  @click="medicationByResident(item)">{{ item.fullName }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-row>
        <!-- <v-card> -->
        <!-- <v-card-text> -->
          <v-data-table
          :headers="headers"
          :items="medications"
          :options.sync="options"
          :server-items-length="totalMedications"
          :loading="loading"
          loading-text="Loading ..... Please wait"
          :footer-props="{
            itemsPerPageOptions: [ 500, 1000, 2000],
            itemsPerPageText: 'Stock Balance per page',
          }"
          update:options
          class="elevation-23"
        >
            <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-dialog v-model="dialog" max-width="500px">

                      <v-card>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.name" label="Medication name"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.directive" label="Directive"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" >
                                <label for="quantity-order"> Quantity Given </label><br>
                                <input v-model="editedItem.quantityGiven" type="number" name="quantity-given" id="input"/>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.action" label="Action"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.comment" label="Comment"></v-text-field>
                              </v-col>
                              <v-datetime-picker label="Date & Time Given"
                                   v-model="editedItem.timeGiven" timePickerFormat="24hr"
                                   dateFormat="dd-MM-yyyy">
                              </v-datetime-picker>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text  @click="close">Cancel</v-btn>
                          <v-btn color="blue darken-1" text  @click="save">Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-row justify="space-around">
                      <span class="group pa-2">
                          <v-icon
                            v-if="$can('update')"
                            small
                            class="mr-2"
                            @click="editItem(item)"
                          >
                            edit
                          </v-icon>
                          <v-icon
                            v-if="$can('delete')"
                            small
                            @click="deleteItem(item)"
                          >
                            delete
                          </v-icon>
                            <v-icon
                              v-if="$can('read')"
                              medium @click="detail_medication(item)">info</v-icon>
                      </span>
                  </v-row>
                </template>
        </v-data-table>
        <!-- </v-card-text> -->
         <div class="table-footer-prepend d-flex pl-2 align-center"  v-if='selectedId'>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            class="mr-3"
            v-on="on"
            @click="addNew()"
          >
          Register
            <!-- <v-icon>mdi-plus-circle</v-icon> -->
          </v-btn>
        </template>
        <span>Register new medication</span>
      </v-tooltip>
         </div>
        <!-- <div class="buttons-container">
            <v-btn v-if='selectedId' @click="addNew()">Register</v-btn>
        </div> -->
      <!-- </v-card>  -->
    </v-container>
</section>
</template>
<script>
import {  mapActions } from 'vuex'
import medicationAdministrationApi from '../../services/api/MedicationAdministrationApi';
import residentApi from '@/services/api/ResidentApi';
import moment from 'moment';
export default {
    name: 'medication',
    components: {
    },
    data () {
        return {
            dialog: false,
            medications: [],
            residents: [],
            searchResident: '',
            totalMedications: 0,
            loading: true,
            options: {},
            search: '',
            residentId:'',
            selectedId:'',
             headers: [
                { text: 'Medication Name', value: 'name', class: 'success--text font-weight-bold',},
                { text: 'Resident', value: 'resident.fullName', class: 'success--text font-weight-bold' },
                { text: 'Description', value: 'description',  sortable: false, class: 'success--text font-weight-bold' },
                { text: 'Directive', value: 'directive',  sortable: false, class: 'success--text font-weight-bold' },
                { text: 'Action', value: 'action',  sortable: false, class: 'success--text font-weight-bold' },
                { text: 'Comment', value: 'comment',  sortable: false, class: 'success--text font-weight-bold' },
                { text: 'Time Given', value: 'timeGiven', class: 'success--text font-weight-bold' },
                { text: 'Quantity Given', value: 'quantityGiven', class: 'success--text font-weight-bold' },
                { text: 'Actions', value: 'actions', sortable: false, class: 'success--text font-weight-bold' },
            ],
              editedItem: {
                name: '',
                directive: '',
                description: '',
                action: '',
                comment: '',
                timeGiven: null,
                quantityGiven: '',
              },
              defaultItem: {
                name: '',
                directive: '',
                description: '',
                action: '',
                comment: '',
                timeGiven: null,
                quantityGiven: '',
              },
               menu2: false,
        }
    },
    methods: {
        ...mapActions([
            'update_medication_administration',
        ]),
        editItem (item) {
            this.editedItem = Object.assign({}, item)
            this.defaultItem.timeGiven = item.timeGiven;
            this.dialog = true
        },

        deleteItem (item) {
          confirm('Are you sure you want to delete this medication?') && this.delete_medication(item)
          const index = this.medications.indexOf(item)
          this.medications.splice(index, 1)
        },

        close () {
          this.dialog = false
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300)
        },

        save () {
            delete this.editedItem.resident;
            delete this.editedItem.createdOn;
            delete this.editedItem.modifiedOn;
            delete this.editedItem.user;
            if (this.defaultItem.timeGiven != this.editedItem.timeGiven){
               this.editedItem.timeGiven = this.formatDate(this.editedItem.timeGiven);
            }
            this.update_medication_administration({...this.editedItem})
          this.close()
        },
        get_medication_list_administration () {
          this.loading = true
          return new Promise((resolve, reject) => {
              const { sortBy, sortDesc, page, itemsPerPage } = this.options
              if (sortDesc && sortDesc.length && sortDesc[0] == false){
                var orde = 'asc'
              }
              else{
                 orde = 'desc'
              }
              if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homeId = ''
                  }
                  else{
                    homeId = localStorage.getItem('homeId')
                  }
              medicationAdministrationApi.getRegisteredMedication({page: page, count:itemsPerPage, id:'', home:homeId,q:'', orderBy: sortBy && sortBy[0], order: orde})
                .then(medications => {
                    this.medications = medications.result
                    this.totalMedications = medications.count
                })
                .catch(error => {
                    return reject(error)
                })
              setTimeout(() => {
                this.loading = false
                }, 1000)
          })
        },
        delete_medication(item) {
            medicationAdministrationApi.deleteRegisteredMedication(item.id)
                .then(medication => {
                    return ("deleted" + medication);
                })
        },
        detail_medication(medication){
          // this.$store.commit('add_medication', medication);
          this.$router.push({ name: 'medicationAdministrationDetail', params: {medicationId:medication.id, totalMedications:this.totalMedications}})
        },
        formatDate(date) {
          return moment(date).format('DD-MM-YYYY HH:mm')
        },
        get_resident_list () {
              return new Promise((resolve, reject) => {
                  if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homecode = ''
                  }
                  else{
                    homecode = localStorage.getItem('homeCode')
                  }
                  residentApi.getResidents({page: '', count:'', home:homecode, q:''})
                    .then(residents => {
                        this.residents = residents.result
                        this.totalResidents = residents.count
                    }).catch(error => {
                        return reject(error)
                    })
                  setTimeout(() => {
                    this.loading = false
                    }, 1000)
              })
        },
      medicationByResident(resident) {
          var id = resident.id;
          this.selectedId = resident.id;
          this.searchResident = resident.fullName
          return new Promise((resolve, reject) => {
                  medicationAdministrationApi.getRegisteredMedication({page:'', count:'', id:id, q:''})
                    .then(medications => {
                      this.medications = medications.result
                      this.totalMedications = medications.count
                    })
                    .catch(error => {
                      return reject(error)
                    })
                })
      },
      addNew() {
        this.$router.push({ name: 'registerMedicationAdministration', params: {residentId:this.selectedId}});
      }
    },
    created() {
        // this.residentId = this.$route.params.residentId;
        // this.$store.commit('remove_all_medication');
        this.get_medication_list_administration();
    },
    beforeMount(){
      this.get_resident_list();
    },
    watch: {
        options: {
          handler () {
            this.get_medication_list_administration()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          },
          deep: true,
        },
        '$route.params.residentId': {
          handler () {
            this.residentId = this.$route.params.residentId;
            this.get_medication_list_administration()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          },
          deep: true,
          immediate: true,
        },
        dialog (val) {
          val || this.close()
        },
        editedItem: function() {
          this.get_medication_list_administration()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
        },
        search: function() {
          this.searchResident = ''
          this.selectedId = ''
          if(this.search.length > 0){
            if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homeId = ''
                  }
                  else{
                    homeId = localStorage.getItem('homeId')
                  }
              return new Promise((resolve, reject) => {
                  medicationAdministrationApi.getRegisteredMedication({page:'', count:'', id:'',home:homeId, q:this.search})
                    .then(medications => {
                        this.medications = medications.result
                        this.totalMedications = medications.count
                    })
                    .catch(error => {
                        return reject(error)
                    })
                })
          }
          if(this.search.length <= 0){
            this.get_medication_list_administration()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          }
        },
        searchResident: function(){
            if(this.searchResident.length <= 0){
              this.selectedId = ''
            this.get_medication_list_administration()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
            this.get_resident_list();
            }
            else if(this.searchResident.length >0){
              return new Promise((resolve, reject) => {
                  if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homecode = ''
                  }
                  else{
                    homecode = localStorage.getItem('homeCode')
                  }
                  residentApi.getResidents({page:'', count:'', home:homecode, q:this.searchResident})
                    .then(residents => {
                        this.residents = residents.result
                        this.totalResidents = residents.count
                    }).catch(error => {
                        return reject(error)
                    })
                  setTimeout(() => {
                    this.loading = false
                    }, 1000)
              })
          }
        },
    },
}
</script>
<style lang="scss">
  #input {
    width: 70%;
  }
  .table-footer-prepend {
  margin-top: -58px;
  height: 58px;
  margin-left: 400px;
}

</style>
